jQuery(document).ready(function ($) {
  $(".slide-articles").slick({
    dots: true,
    infinite: true,
    speed: 300,
    appendDots: $("#slick-dots-container"),
  });
});
